import * as recallApi from '@otter-ai/recall-client';
import {
  AppId,
  CheckEmailResponse as CheckEmail,
} from '@otter-ai/recall-client';
import { createEmailCheckSignature } from '#utils';

const queryKey = ['check_email'] as const;
type QueryKey = typeof queryKey;

type CheckEmailQueryParams = {
  email: string;
  enabled?: boolean;
};

export type CheckEmailQuery = {
  readonly queryKey: QueryKey;
  readonly queryFn: () => Promise<CheckEmail>;
  readonly enabled?: boolean;
};

export function checkEmailQueryCreator({
  email,
  enabled = true,
}: CheckEmailQueryParams): CheckEmailQuery {
  return {
    queryKey,
    queryFn: async () => {
      const signatureBody = await createEmailCheckSignature(email);
      const body = {
        email,
        ...signatureBody,
      };

      const response = await recallApi.checkEmail({
        query: {
          appid: process.env.NEXT_PUBLIC_APP_ID as AppId,
          email,
        },
        body,
      });

      if (response.error) {
        throw response.data;
      }
      return response.data;
    },
    enabled: enabled && !!email,
  };
}
